import React from 'react'
import { Link } from 'react-router-dom'

class Navbar extends React.PureComponent {
  render = () => {
    const nav = []
    const validPaths = this.props.validPaths[this.props.type] || []

    const location = this.props.location.pathname
    validPaths.map((path, i) => {
      nav.push(
        <Link
          key={`nav-${i}`}
          to={path}
          className={location === path ? 'selected' : null}
        >
          {i + 1}. {this.props.polyglot.t(path.split('/')[1])}
        </Link>
      )
    })
    if (this.props.isAdmin) {
      this.props.adminPaths.map((path, i) => {
        nav.push(
          <Link
            key={`nav-${i + validPaths.length + 1}`}
            to={path}
            className={location === path ? 'selected' : null}
          >
            {i + validPaths.length + 1}.{' '}
            {this.props.polyglot.t(path.split('/')[1])}
          </Link>
        )
      })
    }
    nav.push(
      <a
        key={`nav-${validPaths.length +
          (this.props.isAdmin ? this.props.adminPaths.length : 0) +
          1}`}
        href='//mypassword.nlg.gr/'
        target='_blank'
      >
        {validPaths.length +
          (this.props.isAdmin ? this.props.adminPaths.length : 0) +
          1}. {this.props.polyglot.t('password')}
      </a>
    )

    return <div className='tabs'>{nav}</div>
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/navbar.js